import { useContext } from "react";

import { AssistantChatContext } from "#/context/AssistantChatContext";

export const useAssistantChat = () => {
  const ctx = useContext(AssistantChatContext);
  if (!ctx) {
    throw new Error(
      "useAssistantChat must be used inside AssistantChatProvider"
    );
  }
  return ctx;
};
